module.exports = __webpack_public_path__ + "static/img/logo.200c7e75.svg";